import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ReceiptSendingActionResponse {
  /**
   * Indicates if action on charge is allowed.
   */
  @observable
  isAllowed!: boolean;

  /**
   * Indicates if email address is missing.
   */
  @observable
  isEmailAddressMissing!: boolean;

  /**
   * Indicates if order is not paid.
   */
  @observable
  isOrderNotPaid!: boolean;

  /**
   * Indicates if charge was refunded.
   */
  @observable
  isRefunded!: boolean;
}
